import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as FilterIcon } from "../../../assets/Customer/FilterIcon.svg";
import { ReactComponent as FilterIconHover } from "../../../assets/Customer/FilterIconHover.svg";
import CustomTextfield from "../../../components/CustomInputs/CustomTextfield";
import DialogBox from "../../../components/DialogBoxComponent/DialogBox";
import Toast from "../../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../../theme/ThemeContext";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  input: {
    "&:-webkit-autofill": {
      WebkitTextFillColor: "#000 !important",
    },
  },
  dialogbox: {
    "& .MuiDialog-paper": {
      // minWidth: '110vh',
      maxWidth: "600px",
      // marginLeft: "250px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function AddressTypeFilter(props) {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [sites, setSites] = useState();
  const { t } = useTranslation();
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [isHovered, setIsHovered] = useState(false);
  const [filterQuery, setFilterQuery] = useState({
    name: "",
  });
  const classes = useStyles({ darkMode });

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("darkMode");
    } else {
      document.body.classList.remove("darkMode");
    }
    return () => {
      document.body.classList.remove("darkMode");
    };
  }, [darkMode]);

  const defaultFilter = {
    name: "",
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }
  const handleChange = (event) => {
    const name = event.target.name;
    setFilterQuery({
      ...filterQuery,
      [name]: event.target.value,
    });
  };

  const handleClose = () => {
    setFilterQuery(defaultFilter);
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  const handleSubmit = () => {
    if (filterQuery.name.trim() === "") {
      Toast(t("COMMON015"), "error");
      return;
    }
    props.onSubmit(filterQuery);
    handleClose();
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const reset = () => {
    // if (filterQuery.name.trim() === "") {
    //   Toast(t("COMMON027"), "error");
    //   return;
    // }
    // setFilterQuery(defaultFilter);
    setOpen(false);
  };

  return (
    <>
      <span
        className={darkMode ? "filterdark" : "filter"}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={handleOpen}
      >
        {isHovered ? (
          <Tooltip
            title={
              <Typography fontSize={12} fontWeight={500}>
                {t("COMMON006")}
              </Typography>
            }
          >
            <FilterIconHover
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <AddressTypeFilter />
            </FilterIconHover>
          </Tooltip>
        ) : (
          <Tooltip
            title={
              <Typography fontSize={12} fontWeight={500}>
                {t("COMMON006")}
              </Typography>
            }
          >
            <FilterIcon
              style={{
                cursor: "pointer",
                color: darkMode ? "#fff" : "#474a4e",
              }}
            >
              <AddressTypeFilter />
            </FilterIcon>
          </Tooltip>
        )}
      </span>

      <DialogBox
        Header={
          <span
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("COMMON006")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("COMMON024")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        open={open}
        onClose={handleClose}
        onSubmit={handleSubmit}
        cancel={handleClose}
      >
        <Grid
          container
          justifyContent="center"
          alignItems={"center"}
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Grid item xs={12} sm={12}>
            <CustomTextfield
              label={t("COMMON044")}
              name="name"
              value={filterQuery.name}
              handleChange={(e) => handleChange(e)}
            />
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
